export default __webpack_public_path__ + "static/media/custom-vinyl-banners.6db99529.jpg";